import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { RedirectToLoginService } from "@modules/common/services/redirect-to-login.service";
import { CurrentLoginRequestService } from "@modules/login/services/current-login-request.service";

@Injectable({
    providedIn: 'root'
})
export class LoginRequestRouteGuard implements CanActivate {
    constructor(
        private _currentLoginRequestService: CurrentLoginRequestService,
        private _redirectToLoginService: RedirectToLoginService
    ) { }

    public canActivate(): boolean {
        if (!this._currentLoginRequestService.getCurrentLoginRequest()) {
            this._redirectToLoginService.redirectToLogin();
            return false;
        }

        return true;
    }
}
